import keviApi from "../keviApi";

export function uploadFilesToStorage(files, t, onProgress = null) {
    return new Promise((resolve, reject) => {
        const oversizedFiles = [];
        const MAX_SIZE_MB = 10;
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            if (files[i].size / (1000 * 1000) > MAX_SIZE_MB) {
                oversizedFiles.push(files[i].name);
            } else {
                formData.append("files[]", files[i]);
            }
        }

        if (oversizedFiles.length > 0) {
            return reject(
                new Error(
                    t("inputs-image-oversized", [MAX_SIZE_MB, oversizedFiles.join(", ")])
                )
            );
        }

        const xhr = new XMLHttpRequest();
        xhr.open("POST", keviApi.getOptions("storage/upload").url, true);
        xhr.setRequestHeader("Authorization", keviApi.getAuthHeader().Authorization);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && typeof onProgress === "function") {
                const progress = Math.round((event.loaded * 100) / event.total);
                onProgress(progress);
            }
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response.data || []);
                } catch (err) {
                    reject(new Error(t("inputs-image-parseError")));
                }
            } else {
                try {
                    const errorResponse = JSON.parse(xhr.responseText);
                    reject(new Error(errorResponse.data?.message || t("inputs-image-serverError")));
                } catch (err) {
                    reject(new Error(t("inputs-image-httpError", [xhr.status])));
                }
            }
        };

        xhr.onerror = () => {
            reject(new Error(t("inputs-image-networkError")));
        };
        xhr.send(formData);
    });
}
